import { COLLECTIONS, isValidPayload, store, toErrorResult } from './shared';

const normalizeAvaliacaoId = value => String(value);

const validatePayload = (payload, action) => {
  if (!isValidPayload(payload)) {
    return toErrorResult(new Error(`Payload inválido para ${action} de resultado`));
  }

  if (payload.avaliacao_id === null || payload.avaliacao_id === undefined) {
    return toErrorResult(new Error('avaliacao_id is required'));
  }

  return null;
};

const list = async () => store.list(COLLECTIONS.resultados);

const getById = async id => store.getById(COLLECTIONS.resultados, id);

const create = async payload => {
  const validationError = validatePayload(payload, 'criação');
  if (validationError) {
    return validationError;
  }

  return store.create(COLLECTIONS.resultados, {
    ...payload,
    avaliacao_id: normalizeAvaliacaoId(payload.avaliacao_id)
  });
};

const update = async (id, payload) => {
  const validationError = validatePayload(payload, 'atualização');
  if (validationError) {
    return validationError;
  }

  return store.update(COLLECTIONS.resultados, id, {
    ...payload,
    avaliacao_id: normalizeAvaliacaoId(payload.avaliacao_id)
  });
};

const remove = async id => store.remove(COLLECTIONS.resultados, id);

const getByAvaliacaoId = async avaliacaoId => {
  const avaliacaoIdValue = normalizeAvaliacaoId(avaliacaoId);
  const result = await list();

  if (!result.ok) {
    return result;
  }

  const filtered = Array.isArray(result.data)
    ? result.data.filter(
        item =>
          item &&
          item.avaliacao_id !== null &&
          item.avaliacao_id !== undefined &&
          normalizeAvaliacaoId(item.avaliacao_id) === avaliacaoIdValue
      )
    : [];

  return {
    ok: true,
    data: filtered,
    error: null
  };
};

const upsertResultado = async payload => {
  try {
    const validationError = validatePayload(payload, 'upsert');
    if (validationError) {
      return validationError;
    }

    const normalizedPayload = {
      ...payload,
      avaliacao_id: normalizeAvaliacaoId(payload.avaliacao_id)
    };

    const search = await getByAvaliacaoId(normalizedPayload.avaliacao_id);

    if (!search.ok) {
      return search;
    }

    const current = Array.isArray(search.data) && search.data.length > 0 ? search.data[0] : null;

    if (current && current.id) {
      return update(current.id, normalizedPayload);
    }

    return create(normalizedPayload);
  } catch (error) {
    return toErrorResult(error);
  }
};

const resultadosRepo = {
  list,
  getById,
  create,
  update,
  remove,
  getByAvaliacaoId,
  upsertResultado
};

export default resultadosRepo;
